/**
 * Canonical design tokens for the web portal.
 *
 * This module is the single source of truth for colour, spacing, radius,
 * typography and layering. Both the MUI theme (see ThemeContext) and the CSS
 * custom properties in styles/_tokens.scss are derived from these values, so a
 * change here propagates to `sx` props and stylesheets alike.
 *
 * styles/_tokens.scss mirrors this file; theme/__tests__/tokens.test.js fails
 * the build if the two drift apart.
 */

export const palette = {
  accent: '#FFEE20',
  accentBright: '#FFF56B',
  accentContrast: '#000000',

  bg: '#08080C',
  surface: '#0C0C12',
  surfaceRaised: '#10101A',
  border: '#16161F',

  textPrimary: '#E8E8EE',
  textMuted: '#6A6A80',
  textDim: '#3A3A50',

  success: '#0B964B',
  error: '#F20606',
  warning: '#FF9800',
  info: '#00C3FD',
};

/** rgb triplet for the accent, for rgba() composition in both JS and CSS. */
export const accentRgb = '255, 238, 32';

export const radius = {
  sm: 8,
  md: 16,
  pill: 999,
};

export const spacing = [4, 8, 12, 16, 24, 32, 48];

export const fontSize = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  xl: 24,
  xxl: 32,
};

export const fontFamily = {
  display: "'Chakra Petch', 'Inter', system-ui, sans-serif",
  body: "'Inter', system-ui, -apple-system, 'Helvetica Neue', sans-serif",
  mono: "'JetBrains Mono', ui-monospace, 'Courier New', monospace",
};

/**
 * Named layers replacing the ad-hoc 1..1000000000 escalation. Overlays must
 * pick a name here rather than inventing a larger number.
 */
export const zIndex = {
  base: 0,
  raised: 1,
  sticky: 100,
  drawer: 200,
  overlay: 300,
  modal: 400,
  toast: 500,
};
